import { isExternalCompany, isGradingCompany } from 'shared/helpers/matchers/checkCompanyType';

const onlyInternalHedgingAndSettlementAvailable = companyType =>
  companyType && !isGradingCompany(companyType) && !isExternalCompany(companyType);

export { onlyInternalHedgingAndSettlementAvailable };
